import { render, staticRenderFns } from "./DatabaseCleanup.vue?vue&type=template&id=6aac9dbc&scoped=true&"
import script from "./DatabaseCleanup.vue?vue&type=script&lang=js&"
export * from "./DatabaseCleanup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aac9dbc",
  null
  
)

export default component.exports